export const getDeliveryFrequencyLabel = (
  formatMessage: (descriptor: { id: string; defaultMessage: string }) => string,
  frequency: string
): string => {
  switch (frequency) {
    case 'daily':
      return formatMessage({
        id: 'delivery-frequency-daily',
        defaultMessage: 'daily',
      });
    case 'weekly':
      return formatMessage({
        id: 'delivery-frequency-weekly',
        defaultMessage: 'weekly',
      });
    case 'monthly':
      return formatMessage({
        id: 'delivery-frequency-monthly',
        defaultMessage: 'monthly',
      });
    case 'quarterly':
      return formatMessage({
        id: 'delivery-frequency-quarterly',
        defaultMessage: 'quarterly',
      });
    default:
      return frequency;
  }
};
